import React, { useState } from 'react'
import Footer from '../components/footer'
import Navbar from '../components/navbar'
import Button from '../components/input-components/button'
import TextField from '../components/input-components/textfield'
import ErrorLabel from '../components/input-components/error-label'
import { Auth } from 'aws-amplify'
import { type CognitoUser } from '@aws-amplify/auth'
import NewPasswordRequired from '../components/new-password'
import { useNavigate } from 'react-router-dom';

interface LoginProps {
  onAuthChange: (authenticated: boolean) => void
}

const Login = ({ onAuthChange }: LoginProps): JSX.Element => {
  const [isLoadingIndicator, setLoadingIndicator] = useState(false)
  const [emailAddress, setEmailAddress] = useState('')
  const [password, setPassword] = useState('')
  const [errorOccurred, setErrorHasOccurred] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [newPasswordRequired, setNewPasswordRequired] = useState(false)
  const [cognitoUser, setCognitoUser] = useState<CognitoUser>()
  const navigate = useNavigate();

  const onClick = async (): Promise<void> => {
    try {
      setLoadingIndicator(true)
      setErrorHasOccurred(false)

      console.log('Signing in ...')
      await Auth.signIn({
        username: emailAddress,
        password
      })
        .then(async user => {
          // IMPORTANT: If the user has not verified or chosen their new password then you won't be able execute Auth.currentSession or get access key etc.
          // You will need to ask the user to enter their new password and call 'Auth.completeNewPassword(userObject, pass)' in order for the user to move forward.
          if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
            console.log('new password required')
            setCognitoUser(user)
            setNewPasswordRequired(true)
          } else {
            onAuthChange(true)
            navigate('/') // Route user to home page (this will only occur if the user is already logged in and the Auth won't trigger in the use-effect hook on the App page)
          }
        })
        .catch(error => {
          if (error instanceof (Error)) {
            setError(error)
          }
        })

      setLoadingIndicator(false)
    } catch (error) {
      if (error instanceof (Error)) {
        setError(error)
      }
    }
  }

  const setError = (error: Error): void => {
    setErrorHasOccurred(true)
    switch (error.message) {
      case 'Incorrect username or password.':
        setErrorMessage('Incorrect username or password. Please try again.')
        break
      case 'User does not exist.':
        setErrorMessage('Email address does not exist')
        break
      default:
        setErrorMessage('Sorry, an error has occurred. Please try again.')
        break
    }
  }

  return (
    !newPasswordRequired
      ? (
      <div className="flex flex-col h-screen">
            <Navbar />
            <div className="md:container mx-auto justify-center items-center flex-1 flex w-3/4">
                <div className="w-full max-w-md space-y-4 ">
                    {/* Add Sign In Label + Email Address + Password Text Fields. */}
                    <div className="text-gray-600 flex justify-center items-center font-bold"> Sign In</div>
                    <TextField id={'email_address'} type="text" placeholder={'Email Address: example@gmail.com'} setValue={setEmailAddress}/>
                    <TextField id={'password'} type="password" placeholder={'Password'} setValue={setPassword} />
                    <Button id="login" label="Submit" isLoading={isLoadingIndicator} onClick={onClick}></Button>
                    <ErrorLabel id="errorLabel" label={errorMessage} isError={errorOccurred}></ErrorLabel>
                </div>
            </div>
            <Footer />
        </div>
        )
      : (
        <NewPasswordRequired cognitoUser={cognitoUser} onAuthChange={onAuthChange}/>
        )
  )
}

export default Login
